import etamessaging from '../shared/etamessaging';
import ko from 'knockout';
import {propValue} from '../../../utils/object';

var hasOwnProp = Object.prototype.hasOwnProperty;

function ProductViewModel(data) {
    var key;

    for (key in data) {
        if (hasOwnProp.call(data, key)) {
            this[key] = data[key];
        }
    }

    this.estimatedArrivalDateFormatted = ko.computed(
        function () {
            return etamessaging.formatEta(new Date(this.estimatedArrivalDate()));
        }.bind(this)
    );

    this.newDropShipMsg = 'Ships within ';
    this.hasDash = /-/gi.test(this.dropShipDelay());
    this.hasMultiDateRange = /(-|- )(7|6|5|4|3|2|1) business day/gi.test(this.dropShipDelay());
    this.hasSingleDateRange = /^(7|6|5|4|3|2|1) business day/gi.test(this.dropShipDelay());
    this.hasOldDropShipMsg = this.hasDash ? this.hasMultiDateRange : this.hasSingleDateRange;
    this.hasDropShipDelay = !!this.dropShipDelay();
    this.isBackOrder = !!this.backOrderData();
    this.isOutOfStock = this.isBackOrder && !this.hasDropShipDelay;
    this.hasDropShipHolidayCutoff = !!this.dropShipHolidayCutoffDate && this.dropShipHolidayCutoffDate() !== null;

    this.isInHighHolidayVolumePeriod = function (today) {
        if (!this.hasDropShipHolidayCutoff) {
            return false;
        }

        const dropShipHolidayCutoffDate = new Date(this.dropShipHolidayCutoffDate());
        const endYear = dropShipHolidayCutoffDate.getFullYear();
        const endMonth = '12';
        const endDay = '26';
        const endDate = new Date(`${endMonth}/${endDay}/${endYear}`);

        return today <= endDate && dropShipHolidayCutoffDate < today;
    };

    this.buildDropShipDelayMessage = function () {
        if (this.hasDropShipDelay && this.hasOldDropShipMsg) {
            return `${this.newDropShipMsg} ${this.dropShipDelay()}`;
        }

        if (this.hasShippingScheduleDelay()) {
            return this.dropShipDelay();
        }

        if (this.isInHighHolidayVolumePeriod(new Date())) {
            return `This item will not be delivered by 12/25/${new Date().getFullYear()}. Standard product delivery is ${this.dropShipDelay()} but may take longer due to holiday volume.`;
        }

        return `Please allow ${this.dropShipDelay()} for delivery.`;
    };

    this.dropShipDelayMessage = this.buildDropShipDelayMessage();

    this.outOfStockMessage = outOfStockMessage(this.backOrderData());
    this.quantity = ko.observable(1);
    this.isTes = this.type() === 'tes';
    this.customerIsSmartPrimeEligible = smartPak.smartPrimeCookie.SmartPrimeEligible;
    this.dropShipHolidayCutOffDateMessage = this.showDropShipHolidayCutoffDate()
        ? dropShipHolidayCutOffDateMessage(this.dropShipHolidayCutoffDate())
        : '';
    this.showDropShipHolidayCutoffDate = this.showDropShipHolidayCutoffDate();

    this.hasDaysSupply = ko.computed(
        function () {
            return this.daysSupply() > 0;
        }.bind(this)
    );

    this.hasAutoShipDiscount = hasAutoShipDiscount(this.price);

    this.isInvalidPerksEligibleItem = function () {
        var DAYS_SUPPLY_DIFFERENCE_THRESHOLD = 2,
            isEligibleForSmartPerks = !!(
                !isEquineProduct() &&
                this.hasDaysSupply() &&
                +this.originalCostBeforeAutoShip() >= 40
            );

        return (
            isEligibleForSmartPerks && +this.daysSupplyInput() / this.daysSupply() > DAYS_SUPPLY_DIFFERENCE_THRESHOLD
        );
    };
}

function hasAutoShipDiscount(price) {
    return typeof price !== 'function' && !!propValue(price.autoShipDiscount);
}

function outOfStockMessage(backOrderData) {
    if (backOrderData) {
        if (/^w/.test(backOrderData)) {
            return getOutOfStockMessageByWeeks(backOrderData);
        }

        if (/^d/.test(backOrderData)) {
            return getOutOfStockMessageWithDate(backOrderData);
        }
    }

    return '';
}

function getOutOfStockMessageByWeeks(backOrderData) {
    var weeks = backOrderData.split(' ')[1];
    return (
        "This fabulous product is ordered especially for you. Once you place your order, we'll do our best to have this delivered to you in " +
        weeks +
        ' weeks.'
    );
}

function getOutOfStockMessageWithDate(backOrderData) {
    var date = backOrderData.split(' ')[1];
    return 'Preorder now! Expected in stock: ' + date + '.';
}

function isEquineProduct() {
    const $element = document.getElementById('isCanine');
    return $element && $element.value === 'true';
}

function dropShipHolidayCutOffDateMessage(dropShipHolidayCutoffDate) {
    var cutOffDate = new Date(dropShipHolidayCutoffDate),
        day = cutOffDate.getDate(),
        month = cutOffDate.getMonth() + 1,
        year = cutOffDate.getFullYear();

    return cutOffDate ? 'Order by ' + month + '/' + day + '/' + year + ' to receive by 12/25/' + year + '.' : '';
}

export default ProductViewModel;
